/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Colleague_AddInputs */



/**
* | output |
* | --- |
* | "Add colleague" |
*
* @param {Meetings_Colleague_AddInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_colleague_add = /** @type {((inputs?: Meetings_Colleague_AddInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Colleague_AddInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Voeg collega toe")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter un collègue")
	return /** @type {LocalizedString} */ ("Add colleague")
});